import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Button$1 from '../../node_modules/reactstrap/esm/Button.js';
import Theme from '../../Theme/index.js';
import { lightBlue } from '../../assets/colors.js';

var _templateObject, _templateObject2;
var ButtonDef = styled(Button$1)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: ", ";\n  border: ", ";\n  color: ", ";\n  background-color: ", ";\n  border-radius: 0;\n  min-width: 120px;\n  white-space: nowrap;\n  cursor: pointer;\n  text-transform: uppercase;\n  font-size: 12px;\n  ", "\n"])), function (props) {
  return props.outline && "13px 15px" || "15px 20px";
}, function (props) {
  return props.outline && "solid 2px ".concat(lightBlue) || "none";
}, function (props) {
  return props.outline && lightBlue || "white";
}, function (props) {
  return props.outline && "transparent" || lightBlue;
}, function (_ref) {
  var fw = _ref.fw;
  return fw && "width: 100%;";
});
var ButtonLinkDef = styled.a(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  padding: 15px 20px;\n  text-transform: uppercase;\n  font-weight: 400;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  text-decoration: none;\n  color: #fff;\n  background-color: ", ";\n  border-color: ", ";\n\n  &:hover {\n    cursor: pointer;\n    background-color: ", ";\n    border-color: ", ";\n  }\n"])), Theme.colors.lightBlue, Theme.colors.lightBlue, Theme.colors.blue, Theme.colors.blue);
ButtonLinkDef.displayName = "ButtonLink";
ButtonDef.displayName = "Button";
var ButtonDefinitionPropTypes = {
  outline: PropTypes.bool,
  fw: PropTypes.bool
};
ButtonDef.propTypes = ButtonDefinitionPropTypes;
ButtonLinkDef.propTypes = ButtonDefinitionPropTypes;
var Button = ButtonDef;
var ButtonLink = ButtonLinkDef;

export { Button, ButtonLink };
